export const getChipColorByEtatCode = (etatLibelle) => {
    switch (etatLibelle) {
        case "VALIDEE":
            return "success";
        case "SUSPENDU":
            return "error";
        case "EN_INSTANCE_PAIEMENT":
            return "info";
        case "EN_ATTENTE_CONFIRMATION":
            return "info"
        default:
            return "primary";
    }
};

export const getChipColorByEtatCodePackage = (etatLibelle) => {
    switch (etatLibelle) {
        case "EN_EXPLOITATION":
            return "success";
        case "DELETED":
            return "error";
        case "DESACTIVE":
            return "error";
        default:
            return "primary";
    }
};